exports.hoverJS=function(){
    function showHoverBox(event) {
        const hoverBox = document.getElementById('hoverBox');
        hoverBox.style.display = 'block';
  
        const rect = event.target.getBoundingClientRect();
        hoverBox.style.top = `${rect.top + window.scrollY + 20}px`; // Adjust the 20px offset as needed
        hoverBox.style.left = `${rect.left + window.scrollX + 20}px`; // Adjust the 20px offset as needed
  
        document.body.appendChild(hoverBox);
      }
  
      function hideHoverBox() {
        const hoverBox = document.getElementById('hoverBox');
        hoverBox.style.display = 'none';
  
        // Move the hoverBox back to its original position in the DOM
        const originalContainer = document.querySelector('.show-hover-box');
        originalContainer.appendChild(hoverBox);
      }
};
    